import { SignalRProvider } from 'brokertslib/src/context/SignalRProvider'
import { useNavigate } from 'react-router-dom'

import { Loading } from '@/components/Loading'
import CarkulkaExtraOffersProvider from '@/context/CarkulkaExtraOffersProvider'
import { Container } from '../../../components/Container'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { InsuranceInfo } from '../../../containers/InsuranceInfo/InsuranceInfo'
import { OffersCar } from '../../../containers/offers/OffersCar'
import { StepsContent } from '../../../context/StepsContext'
import { useInsuranceParamsContext } from '../../../layouts/Wizard'

const baseUrl = import.meta.env.VITE_BASE_URL
const hubUrl = import.meta.env.VITE_CALCULATION_HUB
const url = `${baseUrl}/${hubUrl}`

export const Step2 = () => {
  const navigate = useNavigate()
  const { insuranceParams, isLoadingData, insuranceParamsId } = useInsuranceParamsContext()

  if (!isLoadingData && insuranceParams && (insuranceParams.generalParams?.lastWizardStep ?? 1) < 2) {
    navigate('/carkulka/extra/wizard/too-far', { replace: true })
  }

  const isContract = !!insuranceParams?.generalParams.contractNumber

  return (
    <Section>
      <Container>
        {isLoadingData && <Loading large={true} />}

        {(!insuranceParamsId || insuranceParams) &&

          <StepsContent step={2}>
            <SignalRProvider url={url}>
              <Steps icon="car" />

              <CarkulkaExtraOffersProvider insuranceParamsId={insuranceParamsId!} isContract={isContract}>
                <InsuranceInfo />

                <OffersCar />
              </CarkulkaExtraOffersProvider>
            </SignalRProvider>
          </StepsContent>
        }

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}
